import { AvailableRoutes } from '@/router/Routes.ts';

export function passToRouteSearchParams(route: AvailableRoutes, params: Record<string, string>) {
  return `${route}?${Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')}`;
}
